import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import formService from './formService'

// Get FormTypes
export const ListFormType = createAsyncThunk('form-type-list', async (params: {}, thunkAPI) => {
  try {
    return await formService.formTypeList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create FormType
export const createFormType = createAsyncThunk('form-type-create', async (data: {}, thunkAPI) => {
  try {
    return await formService.formTypeCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get FormType id
export const editFormType = createAsyncThunk('form-type-edit', async (id: string, thunkAPI) => {
  try {
    return await formService.formTypeEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete FormType
export const deleteFormType = createAsyncThunk('form-type-edit', async (id: string, thunkAPI) => {
  try {
    return await formService.formTypeDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type FormState = {
  record: any
  records: any
  errors: any
}

const initialState: FormState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const formSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListFormType.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createFormType.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = formSlice.actions
export default formSlice.reducer
